<template>
    <div>

        <div v-if="areaScroll" class="print-chart-scroll">
            <div :class="areaStyle">

                <slot>
                    <!-- Additional Content Here -->
                </slot>
                
            </div>
        </div>
        <div v-else>
            <div :class="areaStyle">

                <slot>
                    <!-- Additional Content Here -->
                </slot>
                
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    props: {
        areaScroll: {
            type: Boolean,
            default: true,
        },
        areaWidth: {
            type: String,
            default: '',
        },
    },
    computed: {

        areaStyle () {
            let _prefix_class = 'print-chart-area'
            switch (this.areaWidth)
            {
                case 'full':        return ''
                case 'print-full':  return _prefix_class + '-full'
                default: return _prefix_class
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.area-overflow-x
{
    overflow-x: auto;//scroll;
    overflow-y: hidden;
    white-space: nowrap;
}

.scroll-style-gray
{
    cursor: pointer !important;
    // CSS Scrollbars Module Level 1
    scrollbar-width: thin;
    scrollbar-color: rgba(119, 119, 119, 0.8) rgba(119, 119, 119, 0.5);
}

// 因為就算 print-area 拓寬了，bootstrap 還是會判定 col 錯誤，
// 所以除了報告頁面的 chart 要寫在 class="col-12 col-lg-8" 內，
// 外面還要再包兩層 <div class="print-chart-scroll"> <div class="print-chart-area">  { echarts 圖表在這 }   </div> </div>
.print-chart-scroll
{
    @extend .area-overflow-x;
    @extend .scroll-style-gray;
    margin-bottom: 5px;
    padding-bottom: 5px;
}
.print-chart-area
{
    width: 850px;  // print-area 寬度的 2/3 再小一點點
}
.print-chart-area-full
{
    width: 1100px;
}

</style>